import React from 'react';
import {FormFieldProps} from '../../../@types/components/Form';
import {IEmptyModel} from '../../../@interfaces/IEmptyModel';
import Input from '../fields/Input';

export default function ColorPickerFieldWidget<Model extends IEmptyModel>(props: FormFieldProps<Model>) {
    return <Input {...props} type="color" className="form-control-color"/>;
}
